import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BooleanCheckComponent } from './boolean-check/boolean-check.component';
import { ViewAttachmentFileComponent } from './view-attachment-file/view-attachment-file.component';
import { EOPButtonComponent } from './eop-button/eop-button.component';
import { PayrollsService } from 'app/pages/payrolls/payrolls.service';
import { ReservationService } from 'app/pages/trip-reservations/reservations.service';
import { ClaimButtonComponent } from './claim-button/claim-button.component';
import { BatchClaimButtonComponent } from './batch-claim-button/batch-claim-button.component';
import { ProvidersBillingService } from 'app/pages/providers-billing/providers-billing-service.service';
import { StandingOrderRenderer } from './standing-order-render/standing-order-render.component';
import { BooleanCheckDisabledComponent } from './boolean-check-disabled/boolean-check-disabled.component';
import { ActionsModule } from 'app/pages/actions/actions.module';
import { ProgressBarCellComponent } from './progress-bar-cell/progress-bar-cell.component';
import { GetDateTimeComponent } from './get-date-time/get-date-time.component';
import { ViewAttachmentFileNoClickComponent } from './view-attachment-file-no-click/view-attachment-file-no-click.component';
import { BtnCellRendererComponent } from './btn-cell-renderer/btn-cell-renderer.component';
import { InfoHeaderComponent } from './info-header/info-header.component';

@NgModule({
  imports: [
    CommonModule,
    ActionsModule
  ],
  declarations: [
    GetDateTimeComponent,
    BooleanCheckComponent,
    BooleanCheckDisabledComponent,
    ViewAttachmentFileComponent,
    EOPButtonComponent,
    ClaimButtonComponent,
    BatchClaimButtonComponent,
    StandingOrderRenderer,
    ProgressBarCellComponent,
    ViewAttachmentFileNoClickComponent,
    BtnCellRendererComponent,
    InfoHeaderComponent
  ],
  exports: [
    GetDateTimeComponent,
    BooleanCheckComponent,
    ViewAttachmentFileComponent,
    BooleanCheckDisabledComponent,
    ProgressBarCellComponent,
    ViewAttachmentFileNoClickComponent,
    InfoHeaderComponent,
    BtnCellRendererComponent
  ],
  providers: [
    PayrollsService,
    ReservationService,
    ProvidersBillingService
  ]
})
export class GridComponentsModule { }



// WEBPACK FOOTER //
// ./src/app/pages/A2-utils/grid-components/grid-components.module.ts